import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';

import './GoUpButton.scss';
import useDeviceScroll from '../../hooks/useDeviceScroll';
import Icon from '../Icon/Icon';
import AppModeContext from 'src/containers/AppMode/AppMode.context';

interface GoUpButtonProps {
  refElement?: any,
  showAfterPage?: number
  clientHeight?: number
}

function GoUpButton({ refElement=null, showAfterPage = 4, clientHeight= null }: GoUpButtonProps) {
  const [show, setShow] = useState<boolean>(false);
  const ref = refElement ? refElement.current : window;
  const scrollPosition = useDeviceScroll(ref);
  let height = refElement && !clientHeight ? refElement?.current?.clientHeight : window.innerHeight;
  const { RETAIL_MODE } = useContext(AppModeContext);

  if (clientHeight){
    height = clientHeight;
  }

  useEffect(() => {
    if (scrollPosition > height * showAfterPage && show !== true) {
      setShow(true);
    } else if (scrollPosition < height * showAfterPage && show !== false) {
      setShow(false);
    }
  }, [scrollPosition]);

  const goToTop = () => {
    setShow(false);

    ref.scrollTo(0, 0);
  };

  return (
    <div
      className={
        classNames({
          'go-up-button': true,
          'go-up-button--hide': !show,
          'go-up-button--sticky': !refElement,
          'go-up-button--retail': RETAIL_MODE
        })
      }
      onClick={ goToTop }
    >
      <Icon icon="GoUpArrow" className="go-up-button__arrow" onClick={ goToTop } />
    </div>
  );
}

export default GoUpButton;
